"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.metaPropTypes = exports.inputPropTypes = void 0;

var _propTypes = require("prop-types");

var inputPropTypes = (0, _propTypes.shape)({
  name: _propTypes.string.isRequired,
  onBlur: _propTypes.func.isRequired,
  onChange: _propTypes.func.isRequired,
  onDragStart: _propTypes.func.isRequired,
  onDrop: _propTypes.func.isRequired,
  onFocus: _propTypes.func.isRequired,
  value: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.arrayOf)(_propTypes.string)]).isRequired
});
exports.inputPropTypes = inputPropTypes;
var metaPropTypes = (0, _propTypes.shape)({
  active: _propTypes.bool.isRequired,
  asyncValidating: _propTypes.bool.isRequired,
  autofilled: _propTypes.bool.isRequired,
  dirty: _propTypes.bool.isRequired,
  dispatch: _propTypes.func.isRequired,
  form: _propTypes.string.isRequired,
  invalid: _propTypes.bool.isRequired,
  pristine: _propTypes.bool.isRequired,
  submitFailed: _propTypes.bool.isRequired,
  submitting: _propTypes.bool.isRequired,
  touched: _propTypes.bool.isRequired,
  valid: _propTypes.bool.isRequired,
  visited: _propTypes.bool.isRequired
});
exports.metaPropTypes = metaPropTypes;